export default {
  title: 'Vuosisopimusalennus',
  buttons: {
    edit: 'Muokkaa alennusta',
    save: 'Tallenna alennus',
  },
  toasts: {
    invalid_discount: 'Vuosisopimusalennuksen on oltava välillä {{min}}%–{{max}}%',
  },
};
